const STORAGE_KEY = 'fuelPriceReport.filters';

function loadPersistedFilters() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return {
            regionIds: Array.isArray(parsed.regionIds) ? parsed.regionIds : [],
            fuelIds: Array.isArray(parsed.fuelIds) ? parsed.fuelIds : [],
        };
    } catch (e) {
        return {};
    }
}

function persistFilters(state) {
    try {
        window.localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
                regionIds: state.regionIds,
                fuelIds: state.fuelIds,
            }),
        );
    } catch (e) {
        // ignore quota / private-mode errors
    }
}

const persisted = loadPersistedFilters();

const state = {
    search: null,
    regionIds: persisted.regionIds || [],
    fuelIds: persisted.fuelIds || [],
};

const mutations = {
    setSearch(state, value) {
        state.search = value;
    },
    setRegionIds(state, value) {
        state.regionIds = value;
        persistFilters(state);
    },
    setFuelIds(state, value) {
        state.fuelIds = value;
        persistFilters(state);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/fuel-price-report.js